
import { useMemo } from 'react';
import { useChat } from '@/hooks/useChat';

export function useUnreadMessagesCount() {
  const { conversations } = useChat();

  const unreadCount = useMemo(() => {
    if (!conversations?.length) return 0;
    
    const total = conversations.reduce((total, conversation) => {
      return total + (conversation.unread || 0);
    }, 0);

    // Garantir que sempre retorna 0 ou número positivo
    return Math.max(0, total);
  }, [conversations]);

  // Garantir que retorna número, não string ou undefined
  return typeof unreadCount === 'number' ? unreadCount : 0;
}
